import Toastify from "toastify-js"

function closeTostify(el) {
  const parent = el.closest('.toastify');
  const close = parent.querySelector('.toast-close');

  close.click();
}

window.Toastify = Toastify;
window.closeTostify = closeTostify;
